<script>
  const works = [
    {
      title: "Roos Trommelen Photography",
      image: "roos-trommelen-photography.jpg",
      link: "https://roostrommelen.nl"
    },
    {
      title: "Bicycle Hotel Amsterdam",
      image: "bicycle-hotel-amsterdam.jpg",
      link: "https://bicyclehotel.com"
    },
    {
      title: "TWO-O",
      image: "two-o.jpg",
      link: "https://two-o.com"
    },
    {
      title: "Sarlemijn",
      image: "sarlemijn.jpg",
      link: "http://sarlemijn.com"
    },
    {
      title: "Kappersproducten.nl",
      image: "kappersproducten.jpg",
      link: "https://kappersproducten.nl"
    }
  ];
</script>

<style>
  .work-container {
    display: flex;
    flex-wrap: wrap;
  }

  .work {
    background-color: #fff;
    border-radius: var(--size-xxs);
    font-size: var(--size-m);
  }

  .work img {
    max-width: 100%;
    border-radius: var(--size-xxs);
  }

  h3 {
    font-size: var(--size-m);
    font-weight: bold;
  }
</style>

<article class="m-t-xxxxl" id="portfolio">
  <h2 class="m-b-m">
    Een selectie van
    <strong>mijn werk</strong>
  </h2>

  <div class="work-container">
    {#each works as work}
      <div class="work col-s-4 col-l-4 p-l m-b-l">
        <img
          src="static/images/portfolio/{work.image}"
          alt={work.title}
          class="m-b-s" />

        <h3>{work.title}</h3>
        <a href={work.link} target="_blank">Bezoek website</a>
      </div>
    {/each}
  </div>
</article>
